module.exports = __webpack_public_path__ + "img/img0.76676c22.jpg";